type IsDisabledSaveButtonProps = {
  name: string | null;
  date: string | null;
  place: string | null;
  selectedAttendanceType: string | null;
};

const HYBRID = 'HYBRID';
const FACE_TO_FACE = 'FACE_TO_FACE';

const isAttendanceType = (type: string, value: string): boolean =>
  type === value;

const isHybridAttendanceType = (type: string): boolean =>
  isAttendanceType(type, HYBRID);

const isFaceToFaceAttendanceType = (type: string): boolean =>
  isAttendanceType(type, FACE_TO_FACE);

export const isDisabledSaveButton = ({
  name,
  date,
  place,
  selectedAttendanceType,
}: IsDisabledSaveButtonProps): boolean =>
  !name ||
  !date ||
  !selectedAttendanceType ||
  (isHybridAttendanceType(selectedAttendanceType) && !place) ||
  (isFaceToFaceAttendanceType(selectedAttendanceType) && !place);
